/**
 * MARKA ADI — uygulamanın hangi adla göründüğünü TEK yerden karar verir.
 *
 * ── NEDEN VAR ────────────────────────────────────────────────────────────
 *
 * 11 Eyl 2026, kullanıcı: *"Türkçeden İngilizceye geçince adımız StrayPaw
 * oluyor; onu Türkiye için işaretli olduğunda StrayCats'e çevirebilir
 * miyiz?"*
 *
 * Ölçüldü: `appName` i18n'de YALNIZCA DİLE bağlıydı — `tr` → "Sokak
 * Kedileri", diğer dört dil → "StrayPaw". Ülke hiç sorulmuyordu. Yani
 * Türkiye'deki bir kullanıcı TR/EN düğmesine basınca uygulamanın adı
 * bambaşka bir markaya dönüşüyordu.
 *
 * ── KURAL ────────────────────────────────────────────────────────────────
 *
 *   dil = tr                      → "Sokak Kedileri"
 *   dil ≠ tr  ve  ülke = tr       → "StrayCats"      ← yeni
 *   dil ≠ tr  ve  ülke ≠ tr       → "StrayPaw"
 *
 * Yani ad İKİ ekseni birden izliyor: DİL yüzü seçiyor, ÜLKE hangi
 * uluslararası markanın kullanılacağını seçiyor.
 *
 * ⚠️ AD ÇEVRİLMEZ, SEÇİLİR. Bu yüzden adlar i18n sözlüğüne dağıtılmıyor,
 * burada duruyor: "StrayCats" Portekizce'de de "StrayCats". Sözlüğe koymak,
 * beş dilde beş kopya ve bir gün birbirini tutmayan beş marka demekti —
 * bu depoda aynı ders `lib/odul.js`te bugün ödendi.
 *
 * ⚠️ HUKUKİ METİNLERE DOKUNMUYOR. Kullanım şartları, gizlilik ve topluluk
 * kuralları içindeki "StrayPaw" geçişleri i18n'de KALDI: onlar sözleşme
 * metni ve ayrı bir karar gerektirir (marka adını sözleşmede değiştirmek
 * hukuki bir iştir, görsel bir tercih değil).
 *
 * ⚠️ MAĞAZA ADI AYRI BİR YERDE: iOS'un gördüğü ad `Info.plist`teki
 * `CFBundleDisplayName` ("Sokak Kedileri") ve `capacitor.config.ts`teki
 * `appName`. Bu dosya onları DEĞİŞTİRMEZ; ekranda görünen adı seçer.
 */
import { getCountry } from "../country";

export const MARKA_TR = "Sokak Kedileri";
export const MARKA_TR_ULUSLARARASI = "StrayCats";
export const MARKA_ULUSLARARASI = "StrayPaw";

/**
 * Ekranda görünecek marka adı.
 *
 * @param {string} dil  aktif arayüz dili ("tr", "en", …)
 * @param {string} [ulke] test için; verilmezse kayıtlı ülke okunur
 */
export function markaAdi(dil, ulke) {
  const d = String(dil || "").toLowerCase();
  if (d === "tr") return MARKA_TR;
  // `getCountry()` yalnızca gerektiğinde çağrılıyor: Türkçe yüzde ülkenin
  // hiçbir etkisi yok ve okumaya da gerek yok.
  const u = String(ulke != null ? ulke : (getCountry() || "")).toLowerCase();
  return u === "tr" ? MARKA_TR_ULUSLARARASI : MARKA_ULUSLARARASI;
}

/**
 * Başlıktaki logo dosyası — ADIN KENDİSİNDEN türetiliyor.
 *
 * ⚠️ BU FONKSİYON BİR KEZ YANLIŞ YAZILDI VE KULLANICI CİHAZDA YAKALADI
 * (11 Eyl 2026): *"StrayCats çıkınca İngilizce modda sol yukarıdaki
 * logomuz StrayPaw oluyor."*
 *
 * Yukarıya "ad ile logo ayrışmasın" diye yazmıştım ve hemen altında
 * ayrıştırdım: ad ÜÇ yolu izliyordu (`dil`, sonra `ülke`), logo yalnızca
 * İKİ (`dil === "tr"`). Sonuç: Türkiye'de İngilizceye geçen kullanıcı
 * "StrayCats" adını PATİ ikonuyla görüyordu — iki ayrı markanın parçaları
 * yan yana.
 *
 * ⚠️ DÜZELTME "BİR KOŞUL DAHA EKLEMEK" DEĞİL. Aynı üç yolu ikinci kez
 * yazmak, aynı hatanın üçüncü kez olmasına davetiye olurdu. Logo artık
 * `markaAdi`ın SONUCUNDAN türüyor: tek karar, iki çıktı. Ada yeni bir
 * marka eklenirse logo kendiliğinden onu izler.
 */
const LOGO = {
  [MARKA_TR]: "/app-icon.png",
  [MARKA_TR_ULUSLARARASI]: "/app-icon.png",  // StrayCats = Türkiye yüzü, kedi logosu
  [MARKA_ULUSLARARASI]: "/straypaw-icon.png",
};

export function markaLogosu(dil, ulke) {
  return LOGO[markaAdi(dil, ulke)] || "/straypaw-icon.png";
}
